<template>
  <RenderItem
    styleClass="nostyle"
    :navigation="navigation"
    :selectedObjectId="selectedObjectId"
    @updateNavigation="updateNavigation($event)"
  >
    <span :class="modifiedClasses" :style="style">
      <span
        :contenteditable="computedContentEditable"
        @input="onInput"
        @keydown.enter.prevent
        >{{ computedContent }}</span
      >
      <span v-if="navigation.className == 'BoxZ'">&#x274F;</span>
      <a
        v-if="navigation.className == 'Link'"
        :href="navigation.url"
        target="_blank"
        >@link</a
      >
    </span>
  </RenderItem>
</template>

<script>
import RenderItem from "@/components/document/revision/render/RenderItem";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "InlineObject",
  props: ["navigation", "selectedObjectId"],
  components: { RenderItem },
  computed: {
    computedSelected() {
      if (
        this.navigation &&
        this.selectedObjectId &&
        this.navigation.id == this.selectedObjectId
      ) {
        return true;
      }
      return false;
    },
    computedContentEditable() {
      const classNames = [
        "Inline"
        // "TextEntry",
        // "TextField"
      ];
      return (
        this.computedSelected && classNames.includes(this.navigation.className)
      );
    },
    computedContent() {
      if (this.navigation == undefined) {
        return undefined;
      }
      const navigation = this.navigation;
      if (navigation.className == "AmountEntry") {
        return `{amountEntry|${navigation.name}|${navigation.required}}`;
      } else if (navigation.className == "AmountField") {
        return `{amountField|${navigation.name}}`;
        //  } else if (navigation.className == "BoxZ") {
        //   return "&#x274F;";
      } else if (navigation.className == "BoxEntry") {
        return `{boxEntry|${navigation.name}|${navigation.required}}`;
      } else if (navigation.className == "DateEntry") {
        let value = `{dateEntry|${navigation.name}|${navigation.required}`;
        if (navigation.timeOnly) {
          value += "|time only";
        }
        return `${value}}`;
      } else if (navigation.className == "DateField") {
        let value = `{dateField|${navigation.name}`;
        if (navigation.timeOnly) {
          value += "|time only";
        }
        return `${value}}`;
      } else if (navigation.className == "Inline") {
        return navigation.value;
      } else if (navigation.className == "Link") {
        return navigation.title;
      } else if (navigation.className == "LoginClient") {
        return "{loginClient}";
      } else if (navigation.className == "Lookup") {
        return `{lookup|${navigation.name}}`;
      } else if (navigation.className == "Signature") {
        return "{signature}";
      } else if (navigation.className == "SignatureEntry") {
        return `{signatureEntry|${navigation.name}}`;
      } else if (navigation.className == "TextEntry") {
        let value = `{textEntry|${navigation.name}`;
        if (navigation.value) {
          value += `|${navigation.value}`;
        }
        return `${value}|${navigation.required}}`;
      } else if (navigation.className == "TextField") {
        let value = `{textField|${navigation.name}`;
        if (navigation.value) {
          value += `|${navigation.value}`;
        }
        return `${value}}`;
      } else if (navigation.className == "UploadEntry") {
        return `{uploadEntry|${navigation.name}}`;
      } else {
        return undefined;
      }
    },
    style() {
      if (this.navigation.className == "BoxZ") {
        return "font-family: ZapfDingbats;";
      }
      return undefined;
    },
    modifiedClasses() {
      if (this.navigation == undefined) {
        return undefined;
      }
      let value = "";
      if (this.computedSelected) {
        value += " templateSelected";
      }
      if (this.navigation.bold) {
        value += " templateBold";
      }
      if (this.navigation.italic) {
        value += " templateItalic";
      }
      if (this.navigation.underline) {
        value += " templateUnderline";
      }
      if (
        this.navigation.className == "AmountEntry" ||
        this.navigation.className == "BoxEntry" ||
        this.navigation.className == "DateEntry" ||
        this.navigation.className == "SignatureEntry" ||
        this.navigation.className == "TextEntry" ||
        this.navigation.className == "UploadEntry"
      ) {
        value += " templatePlaceholderEntry";
      }
      if (
        this.navigation.className == "AmountField" ||
        this.navigation.className == "DateField" ||
        this.navigation.className == "LoginClient" ||
        this.navigation.className == "LoginClient" ||
        this.navigation.className == "Lookup" ||
        this.navigation.className == "Signature" ||
        this.navigation.className == "TextField"
      ) {
        value += " templatePlaceholder";
      }
      // if (this.navigation.className == "Inline") {
      if (this.navigation.omit) {
        value += this.navigation.omitDefault
          ? " templateOmitDefault"
          : " templateOmit";
      }
      if (
        this.navigation.omitValue &&
        this.navigation.omitValue.value != undefined &&
        this.navigation.omitValue.value
      ) {
        value += " omitHidden";
      }
      // }
      // console.log(this.navigation.className + " " + value);
      return value;
    }
  },
  data() {
    return { timerId: null };
  },
  methods: {
    updateNavigation(navigation) {
      this.$emit("updateNavigation", navigation);
    },
    onInput(e) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        const value = e.target.innerText;
        // console.log(value);
        this.updateSelected(value);
      }, 1750);
    },
    async updateSelected(value) {
      await nbmlaw.put(
        `/cors/admin/document/navigations/${this.navigation.id}/Inline/value`,
        value
      );
      // console.log(response.data);
      this.$emit("triggerRefresh");
    }
  }
};
</script>